import moment from 'moment';

import { ReviewDetailsData } from 'scenes/common/types';

export const defaultReviewDetails: ReviewDetailsData = {
  policyStartDate: moment().format('YYYY-MM-DD'),
};
